<template>
  <div class="reservationBoard">
    <el-dialog
      title="预约看板"
      :visible.sync="visible"
      width="1200px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <div class="header">
          <div class="header_left">
            <div class="header_today" @click="toToday">{{ date === new Date().Format('yyyy-MM-dd') ? '今天' : '回到今天' }}</div>
            <el-select v-if="!isDoctor" class="header_left_doctor" v-model="doctorId" filterable placeholder="请选择医生" @change="doctorChange">
              <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
            </el-select>
          </div>
          <div class="header_center">
            <div class="header_date">
              <div class="header_date_btn">
                <span class="el-icon-arrow-left header_date_btn_icon" @click="switchDate('prev')"></span>
              </div>
              <el-date-picker
                class="header_date_time"
                v-model="date"
                type="date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                :editable="false"
                :clearable="false"
                @change="dateChange">
              </el-date-picker>
              <div class="header_date_btn">
                <span class="el-icon-arrow-right header_date_btn_icon" @click="switchDate('next')"></span>
              </div>
            </div>
          </div>
          <div class="header_right">
            <el-input class="header_right_search" v-model="search" prefix-icon="el-icon-search" placeholder="搜索患者姓名/电话" clearable></el-input>
          </div>
        </div>
        <transition name="fade">
          <div class="reservation" v-show="reservationShow">
            <div class="reservation_thead">
              <table class="reservation_table">
                <thead class="reservation_table_thead">
                  <tr class="reservation_table_thead_tr">
                    <th
                      v-for="key in 5"
                      :key="`th_${pageNo - 1}_${key - 1}`"
                      class="reservation_table_th">
                      <div v-if="list[(pageNo - 1) * 5 + key - 1]" :class="{ reservation_table_th_info: true, active: nowTimeStamp >= list[(pageNo - 1) * 5 + key - 1].appointmentStartTimeStamp && nowTimeStamp < list[(pageNo - 1) * 5 + key - 1].appointmentEndTimeStamp }">{{ list[(pageNo - 1) * 5 + key - 1].classesText }}</div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="reservation_tbody">
              <table class="reservation_table">
                <tbody class="reservation_table_tbody">
                  <tr class="reservation_table_tbody_tr">
                    <td
                      v-for="key in 5"
                      :key="`td_${pageNo - 1}_${key - 1}`"
                      class="reservation_table_td">
                      <div v-if="list[(pageNo - 1) * 5 + key - 1]" class="reservation_sector">
                        <div v-if="!['', null, undefined].includes(list[(pageNo - 1) * 5 + key - 1].classesText)" class="reservation_count">预约人数：{{ list[(pageNo - 1) * 5 + key - 1].reservationNoticeBoardTimes.length }}人</div>
                        <div
                          v-for="(item, index) in list[(pageNo - 1) * 5 + key - 1].reservationNoticeBoardTimes"
                          :key="`reservation_${pageNo - 1}_${key - 1}_${index}`"
                          :class="{ reservation_item: true, match: computeMatchStatus(item) }">
                          <div class="reservation_item_header">
                            <el-popover placement="top-start" trigger="hover">
                              <div>
                                <div class="reservation_item_popover_text">年龄：{{ item.age }}</div>
                                <div class="reservation_item_popover_text">电话：{{ item.patientPhone }}</div>
                              </div>
                              <div slot="reference" class="reservation_item_name">{{ item.patientName }}</div>
                            </el-popover>
                            <div class="reservation_item_time">预计时长：{{ item.serviceTime || 0 }}分钟</div>
                          </div>
                          <div class="reservation_project_list">
                            <div
                              v-for="(project, projectIndex) in item.physioDetails"
                              :key="`project_${pageNo - 1}_${key - 1}_${index}_${projectIndex}`"
                              class="reservation_project_item">
                              {{ projectIndex + 1 }}、{{ project.physioKindName }}
                            </div>
                          </div>
                          <div class="reservation_info">
                            <div class="reservation_source">
                              <span v-if="item.source">来源：{{ item.source | formatSource }}</span>
                            </div>
                            <div v-if="reservationStatusMap[item.reservation]" :class="`reservation_status ${reservationStatusMap[item.reservation] && reservationStatusMap[item.reservation].class || ''}`">{{ reservationStatusMap[item.reservation] && reservationStatusMap[item.reservation].text || '' }}</div>
                          </div>
                          <div v-if="item.sourceDeptName && item.sourceDeptName !== item.deptName" class="reservation_sourceDept">开单医馆：{{ item.sourceDeptName }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="list.length > 5" class="reservation_switch">
              <div class="reservation_switch_btn" @click="switchPage('prev')">
                <img class="reservation_switch_icon" src="@/assets/images/reservation/arrow-left.png" />
              </div>
              <div class="reservation_switch_btn" @click="switchPage('next')">
                <img class="reservation_switch_icon" src="@/assets/images/reservation/arrow-right.png" />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getPhysioReservationBoard } from '@/api/physio.js';
  export default {
    name: 'reservationBoard',
    filters: {
      formatSource (source) {
        const sourceMap = {
          'applet': '小程序-已购买预约',
          'applet-quick': '小程序-未购买预约',
          'platform': '平台-已购买预约',
          'trilateral': '平台-未购买预约',
          'platform-intermediary': '三方平台',
          'weapp-doctor': '医生小程序-已购买预约',
          'weapp-doctor-quick': '医生小程序-未购买预约'
        }
        return sourceMap[source]
      }
    },
    data () {
      return {
        visible: false,
        loading: false,
        reservationStatusMap: {
          '1': { text: '已预约', class: 'success' },
          '2': { text: '已取消', class: 'finished' },
          '3': { text: '已执行', class: 'finished' },
          '4': { text: '已停诊', class: 'finished' },
          '5': { text: '已结束', class: 'finished' },
          '6': { text: '已签到', class: 'success' }
        },
        reservationShow: true,
        deptId: '',
        isDoctor: false,
        doctorOptions: [],
        doctorId: '',
        search: '',
        date: '',
        datePickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
          }
        },
        nowTimeClock: null,
        nowTimeStamp: new Date().getTime(),
        pageNo: 1,
        list: []
      }
    },
    created () {},
    methods: {
      doctorChange () {
        this.getDetail()
      },
      computeAge (birthday) {
        const birthDate = new Date(birthday)
        const currentDate = new Date()

        // 计算年龄
        let age = currentDate.getFullYear() - birthDate.getFullYear()
        const monthDiff = currentDate.getMonth() - birthDate.getMonth()
        const dayDiff = currentDate.getDate() - birthDate.getDate()

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--
        }

        // 计算月份
        let months = monthDiff;
        if (dayDiff < 0) {
          months -= 1;
        }
        if (months < 0) {
          months += 12;
        }
        
        return `${age}岁${months}月`
      },
      async getDetail () {
        if (!this.doctorId) {
          return false
        }
        this.loading = true
        const res = await getPhysioReservationBoard({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: `${this.date} 00:00:00`,
          endTime: `${this.date} 23:59:59`
        })
        this.loading = false
        if (res.code === 200) {
          const size = Math.max(Math.ceil(res.data.length / 5), 1)
          let list = new Array(size * 5).fill().map(() => {
            return {
              appointmentStartDateTime: '',
              appointmentStartTimeStamp: '',
              appointmentEndDateTime: '',
              appointmentEndTimeStamp: '',
              reservationNoticeBoardTimes: [],
              classesText: ''
            }
          })

          res.data && res.data.forEach((v, i) => {
            list[i].appointmentStartDateTime = new Date(v.appointmentStartDateTime).Format('yyyy-MM-dd hh:mm:ss')
            list[i].appointmentStartTimeStamp = new Date(v.appointmentStartDateTime).getTime()
            list[i].appointmentEndDateTime = new Date(v.appointmentEndDateTime).Format('yyyy-MM-dd hh:mm:ss')
            list[i].appointmentEndTimeStamp = new Date(v.appointmentEndDateTime).getTime()
            list[i].reservationNoticeBoardTimes = v.reservationNoticeBoardTimes.map(reservation => {
              reservation['age'] = this.computeAge(reservation.birthday)
              return reservation
            })
            list[i].classesText = `${new Date(v.appointmentStartDateTime).Format('hh:mm')}~${new Date(v.appointmentEndDateTime).Format('hh:mm')}`
          })

          this.list = list
        }
      },
      open () {
        this.date = new Date().Format('yyyy-MM-dd')
        
        const user = JSON.parse(sessionStorage.getItem('user'))
        this.deptId = sessionStorage.getItem('deptId') || ''
        this.isDoctor = user.type === '0'
        this.doctorId = user.doctorId || ''

        if (this.isDoctor) {
          this.getDetail()
        } else {
          this.$getDoctorOptions()
        }

        this.visible = true

        this.nowTimeClock = setInterval(() => {
          this.nowTimeStamp = new Date().getTime()
        }, 5000)
      },
      close () {
        this.visible = false

        this.search = ''
        this.pageNo = 1
        this.list = []

        clearInterval(this.nowTimeClock)
      },
      dateChange () {
        this.getDetail()
      },
      switchDate (type) {
        const nowDate = new Date(this.date)
        let date = nowDate
        switch (type) {
          case 'prev':
            if (this.date > new Date().Format('yyyy-MM-dd')) {
              date = nowDate.setDate(nowDate.getDate() - 1)
            }
            break
          case 'next':
            date = nowDate.setDate(nowDate.getDate() + 1)
            break
        }
        if (this.date !== new Date(date).Format('yyyy-MM-dd')) {
          this.date = new Date(date).Format('yyyy-MM-dd')
          this.getDetail()
        }
      },
      toToday () {
        if (this.date !== new Date().Format('yyyy-MM-dd')) {
          this.date = new Date().Format('yyyy-MM-dd')
          this.getDetail()
        }
      },
      switchPage (type) {
        switch (type) {
          case 'prev':
            if (this.pageNo > 1) {
              this.pageNo = this.pageNo - 1
              this.reservationShow = false
            }
            break
          case 'next':
            if (this.pageNo * 5 < this.list.length) {
              this.pageNo = this.pageNo + 1
              this.reservationShow = false
            }
            break
        }
        setTimeout(() => {
          this.reservationShow = true
        }, 300)
      }
    },
    computed: {
      computeMatchStatus () {
        return (item) => {
          let status = false
          if (!['', undefined, null].includes(this.search)) {
            if (item.patientName === this.search || item.patientPhone === this.search) {
              status = true
            }
          }
          return status
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .reservationBoard {
    overflow: hidden;
  }

  .reservationBoard /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #E5E6EB !important;
  }

  .reservationBoard /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }
  
  .reservationBoard /deep/ .el-dialog__body {
    padding: 0;
  }

  .content {
    width: 100%;
  }

  .header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 54px;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 260px;
  }

  .header_today {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    height: 32px;
    font-size: 14px;
    color: #1890FF;
    white-space: nowrap;
    background-color: #FFFFFF;
    border: 1px solid #1890FF;
    border-radius: 2px;
    cursor: pointer;
  }

  .header_left_doctor {
    margin: 0 0 0 20px;
    width: 260px;
  }

  .header_center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header_date {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header_date_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background-color: #FFFFFF;
    border: 1px solid #DCDFE6;
    border-radius: 2px;
    cursor: pointer;
  }

  .header_date_btn_icon {
    font-size: 12px;
    color: #303133;
  }

  .header_date_time {
    margin: 0 16px;
    width: 140px;
  }

  .header_date_time /deep/ .el-input__prefix, .header_date_time /deep/ .el-input__prefix {
    display: none !important;
  }

  .header_date_time /deep/ .el-input__inner {
    padding: 0 0 0 0;
    height: 20px;
    line-height: 20px;
    font-weight: bold;
    font-size: 18px;
    color: #1F2329;
    border: none;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 260px;
  }

  .header_right_search {
    width: 100%;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .reservation {
    position: relative;
    z-index: 1;
    width: 100%;
  }

  .reservation_thead {
    width: 100%;
    height: 40px;
    border-top: 1px solid #E4E4E4;
    border-bottom: 1px solid #E4E4E4;
    box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.08);
  }

  .reservation_tbody {
    width: 100%;
    height: 490px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .reservation_table {
    width: 100%;
    border: none;
    table-layout: fixed;
  }

  .reservation_table_thead {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
  }

  .reservation_table_thead_tr {
    width: 100%;
    height: 40px;
  }

  .reservation_table_th {
    box-sizing: border-box;
    width: 240px;
    height: 40px;
    vertical-align: top;
  }

  .reservation_table_th+.reservation_table_th {
    border-left: 1px solid #E4E4E4;
  }

  .reservation_table_th_info {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
    background-color: #FFFFFF;
  }

  .reservation_table_th_info.active {
    color: #FFFFFF;
    background-color: #1890FF;
  }

  .reservation_table_tbody {
    width: 100%;
  }

  .reservation_table_tbody_tr {
    width: 100%;
  }

  .reservation_table_td {
    box-sizing: border-box;
    width: 240px;
    vertical-align: top;
  }

  .reservation_table_td+.reservation_table_td {
    border-left: 1px solid #E0E0E0;
  }

  .reservation_sector {
    box-sizing: border-box;
    padding: 12px 8px;
    width: 100%;
    min-height: 490px;
  }

  .reservation_count {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .reservation_item {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 8px;
    background-color: #EBF5FF;
    border: 1px solid transparent;
  }

  .reservation_item.match {
    background-color: #FFFBE8;
    border-color: #F6CB00;
  }

  .reservation_item_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  .reservation_item_popover_text {
    font-size: 12px;
    color: #303133;
  }

  .reservation_item_name {
    width: 80px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .reservation_item_time {
    font-weight: bold;
    font-size: 12px;
    color: #666666;
  }

  .reservation_project_list {
    margin: 8px 0 0 0;
    width: 100%;
  }

  .reservation_project_item {
    width: 100%;
    line-height: 17px;
    font-size: 12px;
    color: #1F2329;
  }

  .reservation_info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .reservation_source {
    line-height: 18px;
    font-size: 12px;
    color: #999999;
  }

  .reservation_status {
    flex-shrink: 0;
    margin: 0 0 0 8px;
    padding: 0 6px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    white-space: nowrap;
    border-radius: 2px;
  }

  .reservation_status.success {
    color: #1890FF;
    background-color: #CFE7FF;
  }

  .reservation_status.finished {
    color: #667182;
    background-color: #E1E5EE;
  }

  .reservation_sourceDept {
    margin: 4px 0 0 0;
    width: 100%;
    line-height: 17px;
    font-size: 12px;
    color: #1890FF;
  }

  .reservation_switch {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 2;
    bottom: 27px;
    left: 0px;
    width: 100%;
    visibility: hidden;
  }

  .reservation:hover .reservation_switch {
    visibility: visible;
  }

  .reservation_switch_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    background-color: #1890FF;
    border-radius: 50%;
    box-shadow: 0px 1px 7px 1px #D6E1F2;
    overflow: hidden;
    cursor: pointer;
  }

  .reservation_switch_btn+.reservation_switch_btn {
    margin: 0 0 0 14px;
  }

  .reservation_switch_icon {
    width: 12px;
    height: 12px;
  }

</style>